import { SET_EREQUEST_ID } from './constants';

export const initialState = {
  eRequestId: null,
};

const eRequestReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_EREQUEST_ID:
      state = {
        ...state,
        eRequestId: payload,
      };
      break;

    default:
      break;
  }
  return state;
};

export default eRequestReducers;
